import Vue from "vue";
export default {
  namespaced: true,
  state: {
    loading: false,
    artists: [],
    artistsHeaders: [
      {
        key: "last_name",
        title: "Creator Name",
        sortable: true,
        className: "capitalize",
      },
      {
        key: "tags",
        title: "Tags",
        sortable: true,
        className: "md",
        variables: "tag",
      },
      {
        key: "status",
        title: "Status",
        sortable: true,
        className: "md",
        variables: "status",
      },
      {
        key: "indent",
        className: "indent",
      },
      {
        key: "reorder",
        title: "Reorder Artwork",
        sortable: false,
        className: "mdx",
        variables: "icon",
        icon: "IconReorder",
      },
      {
        key: "edit",
        title: "Edit",
        sortable: false,
        className: "xsm",
        variables: "icon",
        icon: "IconEdit",
      },
      {
        key: "delete",
        title: "Delete",
        sortable: false,
        className: "xsm",
        variables: "icon",
        icon: "IconDelete",
      },
    ],
    searchedArtists: [],
    artist: null,
    changesLoading: false,
    hasMorePages: false,
    page: 1,
    serverError: {
      slug: null,
    },
  },
  getters: {
    getLoading(state) {
      return state.loading;
    },
    getArtistsHeaders(state) {
      return state.artistsHeaders;
    },
    getArtists(state) {
      return state.artists;
    },
    getSearchedArtists(state) {
      return state.searchedArtists;
    },
    getArtist(state) {
      return state.artist;
    },
    getChangesLoading(state) {
      return state.changesLoading;
    },
    getHasMorePages(state) {
      return state.hasMorePages;
    },
    getServerError(state) {
      return state.serverError;
    },
  },
  mutations: {
    setLoading(state, payload) {
      state.loading = payload;
    },
    setArtists(state, payload) {
      let artists = [];
      artists = payload.map(el => {
        let tags = {
          main: "",
          additional: [],
        };
        if (el.tags.length > 0) {
          tags.main = el.tags[0].title;
          tags.additional = el.tags.slice(1);
        }
        return {
          ...el,
          last_name: `${el.last_name}, ${el.first_name}`,
          tags: tags,
          disabledReorder: el.artworks.length === 0,
        };
      });
      if (state.page > 1) {
        state.artists = state.artists.concat(artists);
      } else {
        state.artists = artists;
      }
    },
    setSearchedArtists(state, payload) {
      state.searchedArtists = payload.map(el => {
        return {
          id: el.id,
          title: `${el.last_name}, ${el.first_name}`,
        };
      });
    },
    initialArtist(state) {
      state.artist = null;
    },
    setArtist(state, payload) {
      state.artist = payload;
    },
    setChangesLoading(state, payload) {
      state.changesLoading = payload;
    },
    setPage(state, payload) {
      state.page = payload;
    },
    setHasMorePages(state, payload) {
      state.hasMorePages = payload;
    },
    setError(state, payload) {
      let serverError = state.serverError;
      if (payload != null) {
        for (let i in payload) {
          serverError[i] = payload[i][0];
        }
        state.serverError = serverError;
      } else
        state.serverError = {
          slug: null,
        };
    },
  },
  actions: {
    async apiGetArtists(
      { commit },
      {
        status = "",
        tags = "",
        sort = "last_name",
        order = "asc",
        page = "1",
        search = "",
        search_type = "",
        limit = "",
      }
    ) {
      let success = false;
      commit("setLoading", true);
      commit("setHasMorePages", false);
      let query = {
        status,
        tags,
        sort,
        order,
        page,
        search,
        search_type,
        limit,
      };
      let queryStr = "";
      for (let key in query) {
        if (query[key] != "") {
          queryStr += `${key}=${query[key]}&`;
        }
      }
      await Vue.axios
        .get(`/api/admin/artists?${queryStr}`)
        .then(res => res.data)
        .then(data => {
          success = true;
          commit("setPage", page);
          commit("setHasMorePages", data.hasMorePages);
          commit("setArtists", data.response);
        })
        .finally(() => {
          commit("setLoading", false);
        });
      return success;
    },
    async apiGetSearchedArtists({ commit }, { search = "" }) {
      let success = false,
        limit = "all";
      commit("setChangesLoading", true);

      await Vue.axios
        .get(`/api/admin/artists?limit=${limit}&search=${search}`)
        .then(res => res.data)
        .then(data => {
          success = true;
          commit("setSearchedArtists", data.response);
        })
        .finally(() => {
          commit("setChangesLoading", false);
        });
      return success;
    },
    async apiPostArtist({ commit }, payload) {
      let result = false;
      let data = {
        ...payload,
        status: payload.status != null ? payload.status : "0",
      };
      commit("setChangesLoading", true);
      await Vue.axios
        .post("/api/admin/artist", data)
        .then(res => res.data)
        .then(data => {
          result = true;
          commit("setError", null);
        })
        .catch(e => {
          let response = e.response;
          if (response.status === 422) {
            commit("setError", response.data.detail);
          }
        })
        .finally(() => {
          commit("setChangesLoading", false);
        });
      return result;
    },
    async apiGetArtist({ commit }, id) {
      let result = false;
      await Vue.axios
        .get(`/api/admin/artist/${id}`)
        .then(res => res.data)
        .then(data => {
          result = true;
          commit("setArtist", data.response);
        });
      return result;
    },
    async apiPutArtist({ commit }, payload) {
      commit("setChangesLoading", true);
      let result = false;
      await Vue.axios
        .put(`/api/admin/artist/${payload.id}`, payload)
        .then(res => res.data)
        .then(data => {
          result = true;
          commit("setError", null);
        })
        .catch(e => {
          let response = e.response;
          if (response.status === 422) {
            commit("setError", response.data.detail);
          }
        })
        .finally(() => {
          commit("setChangesLoading", false);
        });
      return result;
    },
    async apiDeleteArtist({ commit }, id) {
      let result = { success: false, message: null };
      await Vue.axios
        .delete(`/api/admin/artist/${id}`)
        .then(res => res.data)
        .then(data => {
          result.success = true;
          result.message = data.message;
        });
      return result;
    },
  },
};
